export default __webpack_public_path__ + "static/media/ruth.33054e2c.png";